<div class="header-version">
  <div class="header-version__version">Ver. {{ version.versionNumber }}</div>
  <div class="header-version__build">Build: {{ version.buildNumber }}</div>
</div>
